export default {
  data() {
    return {
      // Access permissions will be available globally
    }
  },
  
  computed: {
    /**
     * Get the current user's access permissions for the client
     */
    userPermissions() {
      return window.userAccessPermissions || {};
    },
    
    /**
     * Check if user has any permissions for the current client
     */
    hasAnyPermissions() {
      return Object.keys(this.userPermissions).length > 0;
    }
  },
  
  methods: {
    /**
     * Check if user has a specific permission for a section and action
     * @param {string} section - The section (e.g., 'playbooks', 'insights', 'settings')
     * @param {string} action - The action (e.g., 'view', 'edit', 'export')
     * @returns {boolean} - Whether the user has the permission
     */
    hasPermission(section, action) {
      if (!this.userPermissions || !this.userPermissions[section]) {
        return false;
      }
      
      return this.userPermissions[section][action] === true;
    },
    
    /**
     * Check if user has view permission for a section
     * @param {string} section - The section to check
     * @returns {boolean} - Whether the user can view the section
     */
    canView(section) {
      return this.hasPermission(section, 'view');
    },
    
    /**
     * Check if user has edit permission for a section
     * @param {string} section - The section to check
     * @returns {boolean} - Whether the user can edit the section
     */
    canEdit(section) {
      return this.hasPermission(section, 'edit');
    },
    
    /**
     * Check if user has export permission for a section
     * @param {string} section - The section to check
     * @returns {boolean} - Whether the user can export from the section
     */
    canExport(section) {
      return this.hasPermission(section, 'export');
    },
    
    /**
     * Check if user has any permission for a section
     * @param {string} section - The section to check
     * @returns {boolean} - Whether the user has any permissions for the section
     */
    hasAnyPermissionFor(section) {
      if (!this.userPermissions || !this.userPermissions[section]) {
        return false;
      }
      
      return Object.values(this.userPermissions[section]).some(permission => permission === true);
    },
    
    /**
     * Get all sections the user has permissions for
     * @returns {Array} - Array of section names
     */
    getPermittedSections() {
      if (!this.userPermissions) {
        return [];
      }
      
      return Object.keys(this.userPermissions).filter(section => 
        this.hasAnyPermissionFor(section)
      );
    }
  }
} 